module.exports = __webpack_public_path__ + "static/media/BANANA-XVS-BNB.43aad0ce.svg";